import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { CatalogRepositoryToken } from '../../di/tokens';
import type { ProductExternalKeyInput } from '../../domain/entities/catalog.entity';

/**
 * O entregável casado pela chave externa — bloco "Entregável no Catalog" da
 * tela da oferta (`/offers/:id`). `key` nulo (chave da oferta incompleta —
 * conta de gateway não resolvida) desliga a query em vez de consultar.
 */
export function useProductByExternalKey(key: ProductExternalKeyInput | null) {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'product-by-external-key', key],
    queryFn: () => repository.findProductByExternalKey(key!),
    staleTime: 1000 * 60 * 5,
    enabled: !!key,
    retry: false,
  });
}
